module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    staticStyle: {
      "padding-top": "150px"
    },
    attrs: {
      "id": "acknowledgment"
    }
  }, [_c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("We are but visiting this earth…")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("It is not the length of our stay which matters")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("so much as the footprints we leave behind…")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("The impression we make upon humanity…")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("A man’s value is measured by how long he is")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("remembered after he is gone…")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bdde7154","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Section0001.vue
// module id = 75
// module chunks = 0